import React from "react";
import { useRouteError } from "react-router";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import Navbar from "@/components/structure/Navbar";

const ErrorPage: React.FC = () => {
  const error = useRouteError() as { statusText?: string; message?: string };

  return (
    <div className="bg-white text-gray-900 min-h-screen w-full flex flex-col">
      {/* Header */}
      <Navbar showLoginStatus={false} />

      {/* Error Body */}
      <div className="m-8 text-gray-950 bg-red-100 flex">
        <div className="p-8 bg-red-200">
          <FontAwesomeIcon
            className="text-4xl text-red-900"
            icon={faExclamationTriangle}
          />
        </div>
        <div className="p-8">
          <h1 className="text-xl font-extrabold">ClarifAI Error</h1>
          <p>{error?.statusText || error?.message || "Unknown error"}</p>
          <p className="text-sm text-gray-600">
            If you think this is a bug, please <a href="" target="_blank" className="outlink">report it on our GitHub repository</a>.
          </p>
          <p className="text-sm text-gray-600">
            Return to <a href="/" className="outlink">ClarifAI</a>.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ErrorPage;
